// © Microsoft Corporation. All rights reserved.

import React from "react";
import { SocialClassNameContract } from "../../Social.classnames";
import { Tag } from "@msnews/social-data-service";
import { close2 } from "../../utils/icons";

interface TagInputProps{
    className?: string,
    managedClasses?: SocialClassNameContract;
    placeholder?: string;
    onChange?: (items: Array<Tag>) => void;
    options: Array<Tag>,
    items: Array<Tag>
}

export default class TagInput extends React.Component<TagInputProps> {
    containerRef: React.RefObject<HTMLDivElement>;
    inputRef: React.RefObject<HTMLSelectElement>;

    constructor(props) {
        super(props);
        this.containerRef = React.createRef<HTMLDivElement>();
        this.inputRef = React.createRef<HTMLSelectElement>();
    }

    addItem(value: Tag) {
        if (this.props.items.find(item => item.id == value.id)) { return; }
        this.itemsChanged([...this.props.items, value]);
    }

    removeItem(value: Tag) {
        if (!this.props.items.find(item => item.id == value.id)) { return; }
        this.itemsChanged(this.props.items.filter(item => item.id != value.id));
    }

    itemsChanged(newItemList) {
        if (this.props.onChange) { this.props.onChange(newItemList); }
    }

    renderItem(item: Tag) {
        return (
            <div key={item.id} className="cwt-tag-item">
                {item.title}
                <i className="cwt-icon" onClick={this.removeItem.bind(this, item)}> {close2} </i>
            </div>
        );
    }

    containerClickHandler(event) {
        event.stopPropagation();
        if (event.currentTarget.classList.contains(this.props.managedClasses.tagInputContainer)) {
            this.inputRef.current.focus();
        }
    }

    inputKeyDownHandler(event) {
        event.stopPropagation();
        if (event.key === "Enter") {
            if (event.target.value.trim().length < 1) { return; }

            this.addItem(JSON.parse(event.target.value));
            event.target.value = "";
        }
    }

    render() {
        const { className, managedClasses, placeholder, options, items } = this.props;

        return (
            <div className={`${managedClasses.tagInputContainer} ${className}`} ref={this.containerRef} onClick={this.containerClickHandler.bind(this)}>
                {items.map((item) => this.renderItem(item))}
                <select className="cwt-tag-input" onKeyDown={this.inputKeyDownHandler.bind(this)} ref={this.inputRef}>
                    <option value="">{placeholder}</option>
                    {options.map(option => <option key={option.id} value={JSON.stringify(option)}>{option.title}</option>)}
                </select>
            </div>
        );
    }
}
